import { VEHICLE_URL } from 'src/config/api.config';
import ApiService from './Api.service';

class VehicleService extends ApiService {
  constructor() {
    super(VEHICLE_URL);
  }

  getPublicVehicleDetails = async (params) => {
    return this.doGet(`${VEHICLE_URL}/public`, params, { ...this._headers });
  };

  getVehiclePosition = async (vehicleId) => {
    return this.doGet(
      `${VEHICLE_URL}/position/track`,
      { vehicleId },
      { ...this._headers }
    );
  };

  getVehicleSummary = async (params) => {
    return this.doGet(
      `${VEHICLE_URL}/summary`,
      { ...params },
      { ...this._headers }
    );
  };

  getVehiclePlayback = async (params) => {
    return this.doGet(
      `${VEHICLE_URL}/position/playback`,
      { ...params },
      { ...this._headers }
    );
  };

  getVehicleTimeline = async (query) => {
    return this.doGet(`${VEHICLE_URL}/trips/timeline`, query, {
      ...this._headers
    });
  };

  getVehicleStatus = async (query) => {
    return this.doGet(`${VEHICLE_URL}/statuses`, query, { ...this._headers });
  };

  LinkUnlinkDevice = async (payload, type, vehicleId) => {
    return this.doPut(`${VEHICLE_URL}/device/${type}/${vehicleId}`, payload, {
      ...this._headers
    });
  };

  createBulkVehicle = async (payload) => {
    return this.doPost(`${VEHICLE_URL}/bulk`, payload, null, {
      ...this._headers
    });
  };

  activateTracking = async (vehicleId) => {
    return this.doPost(`${VEHICLE_URL}/activate-tracking/${vehicleId}`);
  };

  deActivateTracking = async (vehicleId) => {
    return this.doPost(`${VEHICLE_URL}/deactivate-tracking/${vehicleId}`);
  };
  swapVehicle = async (payload) => {
        return this.doPost(`${VEHICLE_URL}/swap`, payload, null, {
      ...this._headers
    });
  };
}

export default new VehicleService();
